'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BVimeo = exports.BYoutube = exports.BVideo = exports.BPicture = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bigpicture = require('./bigpicture');

var _bigpicture2 = _interopRequireDefault(_bigpicture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BPicture = exports.BPicture = function (_Component) {
    _inherits(BPicture, _Component);

    function BPicture(props) {
        _classCallCheck(this, BPicture);

        var _this = _possibleConstructorReturn(this, (BPicture.__proto__ || Object.getPrototypeOf(BPicture)).call(this, props));

        _this.zoomHandle = function () {
            (0, _bigpicture2.default)({
                el: _this.refs.link,
                imgSrc: _this.props.src
            });
        };

        return _this;
    }

    _createClass(BPicture, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'bigpicture link picture', onClick: this.zoomHandle, ref: 'link', title: this.props.caption, style: { display: 'inline-block' } },
                this.props.children
            );
        }
    }]);

    return BPicture;
}(_react.Component);

BPicture.propTypes = {
    src: _propTypes2.default.string.isRequired,
    caption: _propTypes2.default.string
};

var BVideo = exports.BVideo = function (_Component2) {
    _inherits(BVideo, _Component2);

    function BVideo(props) {
        _classCallCheck(this, BVideo);

        var _this2 = _possibleConstructorReturn(this, (BVideo.__proto__ || Object.getPrototypeOf(BVideo)).call(this, props));

        _this2.zoomHandle = function () {
            console.log({ el: _this2.refs.link,
                src: _this2.props.src });
            (0, _bigpicture2.default)({
                el: _this2.refs.link,
                vidSrc: _this2.props.src
            });
        };

        return _this2;
    }

    _createClass(BVideo, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'bigpicture link video', onClick: this.zoomHandle, ref: 'link', title: this.props.caption, style: { display: 'inline-block' } },
                this.props.children
            );
        }
    }]);

    return BVideo;
}(_react.Component);

BVideo.propTypes = {
    src: _propTypes2.default.string.isRequired,
    caption: _propTypes2.default.string
};

var BYoutube = exports.BYoutube = function (_Component3) {
    _inherits(BYoutube, _Component3);

    function BYoutube(props) {
        _classCallCheck(this, BYoutube);

        var _this3 = _possibleConstructorReturn(this, (BYoutube.__proto__ || Object.getPrototypeOf(BYoutube)).call(this, props));

        _this3.zoomHandle = function () {
            (0, _bigpicture2.default)({
                el: _this3.refs.link,
                ytSrc: _this3.props.src.split('=')[1]
            });
        };

        return _this3;
    }

    _createClass(BYoutube, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'bigpicture link video', onClick: this.zoomHandle, ref: 'link', title: this.props.caption, style: { display: 'inline-block' } },
                this.props.children
            );
        }
    }]);

    return BYoutube;
}(_react.Component);

BYoutube.propTypes = {
    src: _propTypes2.default.string.isRequired,
    caption: _propTypes2.default.string
};

var BVimeo = exports.BVimeo = function (_Component4) {
    _inherits(BVimeo, _Component4);

    function BVimeo(props) {
        _classCallCheck(this, BVimeo);

        var _this4 = _possibleConstructorReturn(this, (BVimeo.__proto__ || Object.getPrototypeOf(BVimeo)).call(this, props));

        _this4.zoomHandle = function () {
            var vimeoID = _this4.props.src.split('/');
            (0, _bigpicture2.default)({
                el: _this4.refs.link,
                vimeoSrc: vimeoID[vimeoID.length - 1]
            });
        };

        return _this4;
    }

    _createClass(BVimeo, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'bigpicture link video', onClick: this.zoomHandle, ref: 'link', title: this.props.caption, style: { display: 'inline-block' } },
                this.props.children
            );
        }
    }]);

    return BVimeo;
}(_react.Component);

BVimeo.propTypes = {
    src: _propTypes2.default.string.isRequired,
    caption: _propTypes2.default.string
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-bigpicture/index.js
 ** module id = 1949
 ** module chunks = 3
 **/